export default __webpack_public_path__ + "static/media/person.521e1c6f.svg";